import React from 'react'
import './styles.scss'
import { Container } from 'react-bootstrap'

function Descrip() {
    return (
        <div className="Descrip">
            <Container>
                <h4>Technews:</h4>
                <p className="para">Techseminal provides you to dispense the world's latest technologies and updates.
                The team Techseminal strech out an arm in order to grasp every major happening directly in Technews.
                we also bring forth the opportunity to post your updates by signing in our community. so, straightaway go for it...
                </p>
                <br />
                <h4>Community Media:</h4>
                <p className="para">Yeah! we are very intested in connecting our followers to this community. With this you can post feeds and queries and get answers by
                any other community members who are intersted in interacting with you. we are very proud in getting this type of scheme for you.
                Your can also tech feeds that you are intrested to share with our community members.
                So, get started now to interact with lost of people out there for you. All you need to is signing in....
                </p>
                <br />
                <h4>Freelancing:</h4>
                <p className="para">Finally we are building websites. Award winning desigins for you to make your business or startup look more professional.
                Our team is capable of making beautiful and professional UI and UX designs for very liberal price. we will use latest technologies like React.js, vue.js and
                for backend frameworks like express.js, node.js and many more. So, without any late get a website for your startup..
                </p>
            </Container>
        </div>
    )
}

export default Descrip
